import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PrivateRoute = ({ children, adminOnly = false, memberOnly = false }) => {
  const { user, isAuthenticated, isAdmin, isMember, logout } = useAuth();
  const location = useLocation();

  // Not authenticated - redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // User exists but has no valid role - logout and redirect
  if (user && !user.role) {
    console.error('User has no role, logging out');
    logout();
    return <Navigate to="/" replace />;
  }

  // Admin only route but user is not admin
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Member only route but user is not member
  if (memberOnly && !isMember) {
    return <Navigate to="/" replace />;
  }

  // All checks passed
  return children;
};
